import React from 'react'
import { EditQuestionFlowProvider } from './context/EditQuestionFlowProvider'
import { EditQuestionFlowMain } from './components/EditQuestionFlowMain'

export const EditQuestionFlow = () => {
  return (
    <EditQuestionFlowProvider>
      <EditQuestionFlowMain />
    </EditQuestionFlowProvider>
  )
}
